import axios from "@configs/axios";
import { useMutation } from "@tanstack/react-query";

export const forgetPassword = ({ data }) => {
  return axios.post("/api/forget-password/", data);
};

export const useForgetPassword = ({ config } = {}) => {
  return useMutation({
    ...config,
    mutationFn: forgetPassword,
  });
};
